import { useState } from 'react';
import { Col, Row } from 'antd';
import { CreateQuotationHeader } from './Header';
import { CreateQuotationMain } from './Main';
import { CreateQuotationRightSidebar } from './RightSidebar';

export const CreateQuotationLayout = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const externalSession = localStorage.getItem('external_session') === 'true'; // TODO: pendiente pasar a zustand

  const onNext = () => setCurrentStep((prev) => prev + 1);
  const onPrevious = () => setCurrentStep((prev) => prev - 1);

  return (
    <Row gutter={[16, 32]}>
      <Col span={24}>
        <CreateQuotationHeader isExternal={externalSession} />
      </Col>
      <Col
        xs={{ span: 24, order: 2 }}
        lg={{ flex: '1', order: 1 }}
      >
        <CreateQuotationMain currentStep={currentStep} onNext={onNext} onPrevious={onPrevious} isExternal={externalSession} />
      </Col>
      <Col
        xs={{ span: 24, order: 1 }}
        lg={{ flex: 'none', order: 2 }}
      >
        <CreateQuotationRightSidebar currentStep={currentStep} />
      </Col>
    </Row>
  );
};